import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledTableCell, StyledTableRow, styles } from '../../style/style';


export default function OrderOption(orderOptionsList) {

    // const dataListItem = useSelector((state) => state.orderDetail.orderDetailData.payload);
    const [orderOptions] = useState(orderOptionsList.orderOptionsList)
    console.log("order options");
    console.log(orderOptions);

    const header = [
        'orderdetailcomponents.orderOptionsTable.orderOptionDescription',
        'orderdetailcomponents.orderOptionsTable.orderOptionCode'
    ]

    const headerDefaults = ['Order Option Description', 'Order Option Code']

    return (
        <Box>
            <Typography id="orderOptionsHeader" variant="h5" sx={styles.orderDetailLabels}><FormattedMessage id='orderdetailcomponents.orderOptions' defaultMessage='Order Options' /></Typography>
            <br />
            <TableContainer component={Paper}>
                <Table id="orderOptionTable">
                    <TableHead>
                        <TableRow>
                            {header.map((headerItem, index) => (
                                <TableCell id={headerItem+"Header"} key={index} sx={styles.TableCellHeader}><FormattedMessage id={headerItem} defaultMessage={headerDefaults[index]} /></TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {orderOptions.length !== 0 ? (
                    <TableBody>
                            {orderOptions.map((optionList, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell sx={styles.OrderDetailOptionTableCell}>{optionList.optionDesc}</StyledTableCell>
                                <StyledTableCell sx={styles.OrderDetailOptionTableCell}>{optionList.optionCd}</StyledTableCell>
                            </StyledTableRow >
                        ))} 
                    </TableBody>
                    ) : (
                        <TableBody>
                            <StyledTableRow>
                                <StyledTableCell >
                                    <FormattedMessage id='orderdetailcomponents.orderOptionsTable.noOrderOptionsToDisplay' defaultMessage='No Order Options to Display' />
                                </StyledTableCell>
                            </StyledTableRow > 
                        </TableBody>
                    )}
                </Table>
            </TableContainer>
        </Box >
    )
}
